import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
Vue.directive('animate-on-scroll', {
	inserted(el) {
	  const observer = new IntersectionObserver(
		(entries) => {
		  entries.forEach(entry => {
			if (entry.isIntersecting) {
			  el.classList.add('animate') // 添加动画类
			  observer.unobserve(el)      // 触发后停止观察
			}
		  })
		},
		{ threshold: 0.1 } // 元素可见10%时触发
	  )
	  observer.observe(el)
	}
  })

  Vue.directive('animate-on-scroll-let', {
	inserted(el) {
	  const observer = new IntersectionObserver(
		(entries) => {
		  entries.forEach(entry => {
			if (entry.isIntersecting) {
			  el.classList.add('animateLet') // 添加动画类
			  observer.unobserve(el)      // 触发后停止观察
			}
		  })
		},
		{ threshold: 0.1 } // 元素可见10%时触发
	  )
	  observer.observe(el)
	}
  })
function _isMobile() {
  let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
  if(flag == null){
    console.log(123);
    return;
  }if(flag.length > 0){
    console.log(456);
    store.state.isMobile = true
  }
}
_isMobile()
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
